import { addOrUpdateUniqueStyleTagBeforeSpecificElementInHead } from "@/lib/canvas/assets/dom-utils";
import { prefixBuilderAddedCssTagId } from "@/lib/canvas/assets/css-in-head/utils";

export function addOrUpdateGeneratedGlobalStylesInlineCSSInCanvasHead(
  canvasDocument: Document,
  rawCssCode: string
) {
  addOrUpdateUniqueStyleTagBeforeSpecificElementInHead(
    canvasDocument,
    prefixBuilderAddedCssTagId("global-styles"),
    rawCssCode,
    'meta[name="breakdance:header-assets:css:global-settings"][content="end"]'
  );
}

export function addOrUpdateGeneratedSelectorsInlineCSSInCanvasHead(
  canvasDocument: Document,
  rawCssCode: string
) {
  addOrUpdateUniqueStyleTagBeforeSpecificElementInHead(
    canvasDocument,
    prefixBuilderAddedCssTagId("selectors"),
    rawCssCode,
    'meta[name="breakdance:header-assets:css:selectors"][content="end"]'
  );
}
